import { render, staticRenderFns } from "./SetGiftDetails.vue?vue&type=template&id=e70cb826&"
import script from "./SetGiftDetails.vue?vue&type=script&lang=ts&"
export * from "./SetGiftDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports